import request from './request';

// Fields

export function createField(attrs = {}) {
  return request({
    path: `/v1/fields`,
    type: 'post',
    json: attrs,
  });
}

export function updateField(id, attrs) {
  return request({
    path: `/v1/fields/${id}`,
    type: 'put',
    json: attrs,
  });
}

export function updateFieldIndices(attrs) {
  return request({
    path: `/v1/fields/indices`,
    type: 'put',
    json: attrs,
  });
}

export function deleteField(id) {
  return request({
    path: `/v1/fields/${id}`,
    type: 'delete',
  });
}

export function validEmailDomainCheck(email) {
  return request({
    path: `/v1/email_validations?email=${encodeURIComponent(email)}`,
    type: 'get',
  });
}
